export enum DifalErrorCodeEnum {
    SeedPendente = 1,
}
